import { useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { useBackend } from '../../Hooks/UseBackend';
import { base64ToFile } from '../../utils/base64-to-file';
import * as Form from '../../Components/form';
import { ImageSource } from './types';
import { Spinner } from '../../Components/Spinner';

export function AIImageGenerator({ onImageChange }: ImageSource) {
    const { generateImage } = useBackend();

    const ref = useRef<HTMLTextAreaElement>(null);

    const [loading, setIsLoading] = useState(false);

    return (
        <>
            <Form.Textarea ref={ref} placeholder='Enter prompt here' />
            <Form.Button
                className='w-[103px] h-[33px] flex justify-center items-center text-[14px] font-bold'
                onClick={() => {
                    if (ref.current?.value) {
                        setIsLoading(true);

                        generateImage({
                            prompt: ref.current.value,
                            size: '1024x1024',
                            quality: 'standard',
                            style: 'natural',
                        })
                            .then((data) => {
                                const base64 = `data:image/jpeg;base64,${data}`;
                                const file = base64ToFile(base64, `${ref.current?.value.replace(/\s+/g, '')}.jpg`);

                                onImageChange(base64, file);

                                setIsLoading(false);
                            })
                            .catch((message) => {
                                toast.error(message);
                                setIsLoading(false);
                            });
                    }
                }}
            >
                {loading ? <Spinner /> : 'Generate'}
            </Form.Button>
        </>
    );
}
